<template>
    <div class="phone-actions">
        <LoaderComponent v-if="isLoading" />

        <div
            class="comm-wrapper"
            :class="{
                'status-success': getCommStatus(phone, type, 'Phone') === true,
                'status-failed': getCommStatus(phone, type, 'Phone') === false
            }"
        >
            <a
                :href="`tel:${phone}`"
                class="call-btn"
                @click.prevent.stop="toggleCommDropdown(phone, type, 'Phone')"
            >
                <img src="@/assets/images/phone-icon.svg" alt="Phone" />
            </a>

            <div v-if="getCommStatus(phone, type, 'Phone') === true" class="status-icon success">
                <img src="@/assets/images/communication-green-icon.svg" alt="Success" />
            </div>
            <div
                v-else-if="getCommStatus(phone, type, 'Phone') === false"
                class="status-icon failed"
            >
                <img src="@/assets/images/communication-red-icon.svg" alt="Failed" />
            </div>

            <div
                v-if="
                    activeDropdown.phone === phone &&
                    activeDropdown.type === type &&
                    activeDropdown.comm === 'Phone'
                "
                class="comm-dropdown shadow-sm"
            >
                <div class="dropdown-option" @click.stop="setStatus(phone, type, 'Phone', false)">
                    Не відповідає
                </div>
                <div class="dropdown-option" @click.stop="setStatus(phone, type, 'Phone', true)">
                    Успішний дзвінок
                </div>
            </div>
        </div>

        <div
            v-for="comm in ['WhatsApp', 'Telegram', 'Viber']"
            :key="comm"
            class="comm-wrapper"
            :class="{
                'status-success': getCommStatus(phone, type, comm) === true,
                'status-failed': getCommStatus(phone, type, comm) === false
            }"
        >
            <a
                :href="getMessengerUrl(comm, phone)"
                class="call-btn"
                @click.prevent.stop="toggleCommDropdown(phone, type, comm)"
            >
                <img :src="getMessengerIcon(comm)" :alt="comm" />
            </a>

            <div v-if="getCommStatus(phone, type, comm) === true" class="status-icon success">
                <img src="@/assets/images/communication-green-icon.svg" alt="Success" />
            </div>
            <div v-else-if="getCommStatus(phone, type, comm) === false" class="status-icon failed">
                <img src="@/assets/images/communication-red-icon.svg" alt="Failed" />
            </div>

            <div
                v-if="
                    activeDropdown.phone === phone &&
                    activeDropdown.type === type &&
                    activeDropdown.comm === comm
                "
                class="comm-dropdown"
            >
                <div class="dropdown-option" @click.stop="setStatus(phone, type, comm, false)">
                    Не відповідає
                </div>
                <div class="dropdown-option" @click.stop="setStatus(phone, type, comm, true)">
                    Успішний дзвінок
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComponent from '@/components/LoaderComponent.vue'

export default {
    name: 'CommunicationButtons',
    components: { LoaderComponent },
    props: {
        phone: { type: String, required: true },
        type: { type: String, required: true },
        communications: { type: Object, default: () => ({}) },
        activeDropdown: { type: Object, default: () => ({ phone: null, type: null, comm: null }) },
        isLoading: { type: Boolean, default: false }
    },
    methods: {
        getCommStatus(phone, type, comm) {
            return this.communications?.[type]?.[phone]?.[comm]
        },
        toggleCommDropdown(phone, type, comm) {
            this.$emit('toggle-dropdown', { phone, type, comm })
        },
        setStatus(phone, type, comm, status) {
            this.$emit('set-status', { phone, type, comm, status })
        },
        getMessengerIcon(comm) {
            const icons = {
                WhatsApp: new URL('@/assets/images/whatsapp-icon.svg', import.meta.url).href,
                Telegram: new URL('@/assets/images/telegram-icon.svg', import.meta.url).href,
                Viber: new URL('@/assets/images/viber-icon.svg', import.meta.url).href
            }
            return icons[comm]
        },
        getMessengerUrl(comm, phone) {
            const cleanPhone = this.formatPhoneForMessaging(phone)
            if (comm === 'WhatsApp') return `https://wa.me/${cleanPhone}`
            if (comm === 'Telegram') return `https://t.me/+${cleanPhone}`
            if (comm === 'Viber') return `viber://chat?number=%2B${cleanPhone}`
            return '#'
        },
        formatPhoneForMessaging(phone) {
            if (!phone) return phone
            let cleaned = phone.replace(/\D/g, '')
            if (cleaned.length === 10 && cleaned.startsWith('0')) {
                cleaned = '38' + cleaned
            }
            return cleaned
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common/_variables.scss';

.phone-actions {
    display: flex;
    margin-top: 0.625rem;
    position: relative;
    padding-bottom: 0.5rem;

    .loader-overlay {
        opacity: 0.7;
    }

    .call-btn {
        text-decoration: none;
        margin-right: 1rem;
    }

    .comm-wrapper {
        position: relative;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.625rem 1rem;
        border-radius: 0.625rem;
        border: 1px solid transparent;
        background: $grey-light;

        &.status-success {
            border-color: $green;
        }
        &.status-failed {
            border-color: $red;
        }

        .call-btn {
            width: 1.875rem;
            height: 1.875rem;
            margin-right: 0;
            display: flex;
        }

        .status-icon {
            position: absolute;
            bottom: -0.5rem;
            right: -0.5rem;
            width: 1.25rem;
            height: 1.25rem;
            background: $white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .comm-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            background: $white;
            border-radius: 0.5rem;
            z-index: 100;
            width: max-content;
            margin-top: 5px;
            box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.25);

            .dropdown-option {
                padding: 0.5rem 1rem;
                border-bottom: 1px solid $grey-light;
                white-space: nowrap;
                color: $black;
                font-size: 0.875rem;

                &:last-child {
                    border-bottom: none;
                }
                &:active {
                    background: $grey-light;
                }
            }
        }
    }

    .copy-btn {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: 1.5rem;
            height: 1.5rem;
        }
    }
}
</style>
